
<input
        #colorPickerComponent
        [(colorPicker)]="colorPicker"
       [style.background]="color"
       [style.border-width]="'0px'"
       [style.border-bottom-color]="'rgb(150, 150, 150)'"
       [style.border-bottom-style]="'solid'"
       [style.border-bottom-width]="'1px'"
       [style.width]="'100%'"
       [style.height]="'42px'"
       [cpDialogDisplay]="'popup'"
       [cpToggle]="false"
       (colorPickerChange)="colorChanged($event)"/>
